import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Tutorial.css';
import 'katex/dist/katex.min.css';
import clumpImage from "../assets/clump.png"

function Tutorial() {
  const navigate = useNavigate();

  return (
    <div className="Tutorial">
      <div className="tutorial-header">
        <h1>A Tangled Tutorial</h1>
      </div>

      <div className="tutorial-content">
                  <section className="tutorial-section">
          <h2>🕸️ Game Graph</h2>
          <p>
            Tangled is a graph coloring game where players take turns strategically coloring edges. It can be played on
              any connected graph. On this site we expose six of the seven graphs
              described <a href={"https://fqodzpifyovgmqjlluin.supabase.co/storage/v1/object/public/pdfs/XPRIZE_Phase_I_Submission_Snowdrop.pdf"}>here</a>,
              and add one more (the Petersen graph). Each game graph has one vertex colored red, which is owned by
              player 1, and one vertex colored blue, owned by player 2.
          </p>
        </section>

                  <section className="tutorial-section">
          <h2>📜 Rules</h2>
          <p>
            Players take turns coloring the edges of the game graph grey, green, or purple; red moves first. The game
              ends, and a winner is determined, once all the edges are colored.
          </p>
        </section>

        <section className="tutorial-section">
          <h2>🎮 Game Controls</h2>
          <p>
            Hover over an edge and click on which color you want for that edge.
          </p>
        </section>

        <section className="tutorial-section">
          <h2>❤️️ Interim Scoring Help</h2>
          <p>
            After every move, a glow effect appears around all the vertices in the graph, and an interim
              score appears. The glow effect around each vertex shows that vertex's correlation
              with the red player's vertex minus its correlation with the blue player's vertex. If this
              difference is positive, the glow is red (good for red). If it's negative, it's blue (good for blue).
               The bigger the number the bigger the radius of the glow. The total score is the sum over all these
              numbers. These numbers are computed using simulated annealing, which for
              the small graphs is a good approximator of the real score. As the graphs get bigger, the
              interim results become increasingly untrustworthy, especially when the configuration of edges
              are frustrated (not all edge constraints can be satisfied). So use the glow effects (you want
              as many vertices glowing your color as you can get) as a guide, but realize that the game result
              will not necessarily be what you thought for the larger graphs, as simulated annealing doesn't
              accurately compute scores for the larger graphs. That's why you need a quantum computer!
          </p>
        </section>


<section className="tutorial-section">
  <div style={{ display: 'flex', gap: '40px', alignItems: 'flex-start' }}>
    {/* Left: Text */}
    <div style={{ flex: 1 }}>
      <h2>🎯 Learn How to Win By Playing!</h2>
      <p>
        Once a game is over, the final game configuration is sent to a quantum computer. It then solves a problem in
        quantum magnetism where there is <a href={"https://arxiv.org/pdf/2403.00910v2"}> a claim of quantum advantage</a>. This
        determines the winner of that game. While it is hard to compute who won (by design), you can get an
        intuition for good play given a pattern of edge colors by playing on smaller graphs against weaker players. For
          a complete description of the scoring criteria, see page 8 <a href={"https://fqodzpifyovgmqjlluin.supabase.co/storage/v1/object/public/pdfs/XPRIZE_Phase_I_Submission_Snowdrop.pdf"}>here</a>.
      </p>
    </div>
  </div>
</section>
      </div>
    </div>
  );
}

export default Tutorial;